module.exports = __webpack_public_path__ + "static/media/profile-james.fcd6b9b2.jpg";